/*
  Galerie availability by size.
  Fills every [data-galerie-sizes] panel on the product page with
  "Available" / "Not available" for every size of the selected colour,
  using stock at the Marle Newmarket location.
  Loads the first time the "Check Galerie Availability" panel is opened,
  and refreshes when the colour changes.
*/
(function () {
  const cache = {};
  let loaded = false;
  let requestId = 0;

  function getData() {
    const el = document.querySelector('[data-galerie-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentVariantId(data) {
    const input = document.querySelector('form[id^="product-form-"] input[name="id"]');
    const fromForm = input && parseInt(input.value, 10);
    if (fromForm) return fromForm;
    const fromUrl = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    return fromUrl || data.variants[0].id;
  }

  // Every variant, grouped by its non-size options (e.g. colour), in product order.
  function groupedSizes(data) {
    const groups = [];
    data.variants.forEach((v) => {
      const other = v.options.filter((_, i) => i !== data.sizeIndex).join(' / ');
      let group = groups.find((g) => g.name === other);
      if (!group) { group = { name: other, sizes: [] }; groups.push(group); }
      const label = data.sizeIndex >= 0 ? v.options[data.sizeIndex] : (data.variants.length > 1 ? v.title : 'One Size');
      group.sizes.push({ id: v.id, label: label });
    });
    return groups;
  }

  function fetchStatus(id) {
    if (cache[id]) return cache[id];
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    cache[id] = fetch(`${root}variants/${id}/?section_id=galerie-availability`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('[data-galerie-status]');
        return el ? el.getAttribute('data-galerie-status') : 'unknown';
      })
      .catch(() => 'unknown');
    return cache[id];
  }

  function resizeOpenPanel(container) {
    const panel = container.closest('.accordion-panel');
    if (panel && panel.classList.contains('panel-open')) panel.style.height = panel.scrollHeight + 'px';
  }

  function setAll(html, showNote) {
    document.querySelectorAll('[data-galerie-sizes]').forEach((c) => {
      c.innerHTML = html;
      c.hidden = false;
      const note = c.parentElement.querySelector('[data-galerie-note]');
      if (note) note.hidden = !showNote;
      resizeOpenPanel(c);
    });
  }

  function render() {
    const data = getData();
    if (!data || !data.variants.length) return;
    const allGroups = groupedSizes(data);
    const current = data.variants.find((v) => v.id === currentVariantId(data)) || data.variants[0];
    const currentName = current.options.filter((_, i) => i !== data.sizeIndex).join(' / ');
    const groups = allGroups.filter((g) => g.name === currentName);
    const all = groups.flatMap((g) => g.sizes);
    const myRequest = ++requestId;
    setAll('<p class="salon-availability__loading">Checking availability…</p>', false);

    Promise.all(all.map((s) => fetchStatus(s.id))).then((statuses) => {
      if (myRequest !== requestId) return; // a newer colour was picked
      if (statuses.every((s) => s === 'unknown')) {
        setAll('<p class="salon-availability__loading">Please contact the Galerie to check availability.</p>', false);
        return;
      }
      const status = {};
      all.forEach((s, i) => { status[s.id] = statuses[i]; });
      const html = groups.map((g) => {
        const rows = g.sizes.map((s) => {
          const ok = status[s.id] === 'available';
          return `<div class="salon-availability__size-row"><span>${s.label}</span>` +
            `<span class="salon-availability__size-status${ok ? '' : ' is-unavailable'}">${ok ? 'Available' : 'Not available'}</span></div>`;
        }).join('');
        return rows;
      }).join('');
      setAll(html, true);
    });
  }

  // Load the first time the panel is opened (mobile accordion or desktop drawer link).
  document.addEventListener('click', (e) => {
    if (loaded) return;
    if (e.target.closest('[data-accordion-name*="salon-availability"], [aria-controls*="salon-availability"]')) {
      loaded = true;
      render();
    }
  });

  // Refresh when the shopper changes colour.
  let lastColour = null;
  function onVariantChange() {
    if (!loaded) return;
    const data = getData();
    if (!data) return;
    const v = data.variants.find((x) => x.id === currentVariantId(data));
    const colour = v ? v.options.filter((_, i) => i !== data.sizeIndex).join(' / ') : null;
    if (colour === lastColour) return; // size change only, list is the same
    lastColour = colour;
    render();
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(onVariantChange, 0));
    } else {
      document.addEventListener('change', (e) => {
        if (e.target.closest('variant-radios, variant-selects')) setTimeout(onVariantChange, 50);
      });
    }
  });
})();
